import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 mb-3">
            用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            观众评价
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            听听水果视频平台用户们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.name}
              className="flex flex-col gap-4 p-6 rounded-xl bg-background-100 border border-background-200"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-bold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900 truncate">{item.name}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < item.rating ? 'ri-star-fill text-secondary-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                {item.text}
              </p>
              <span className="text-xs text-foreground-400">{item.time}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}